declare global {
  interface Window {
    QuantumMetricAPI?: {
      getReplay: () => string; // Returns the full replay URL
      getSessionID: () => string; // Returns only the session ID
      isOn: () => boolean; // Checks if Quantum Metric is active
    };
  }
}

export const getQuantumMetricReplayLink = (): string | null => {
  if (window?.QuantumMetricAPI?.isOn()) {
    try {
      const replayURL = window?.QuantumMetricAPI?.getReplay();
      return replayURL || '';
    } catch (error) {
      return 'Error getting Quantum Metric replay URL';
    }
  } else {
    return 'Quantum Metric API is not available or not active.';
  }
};
